import React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const CustomButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "danger"
})(({ danger }) => ({
  backgroundColor: danger ? "#d32f2f" : "#26a69a",
  "&:hover": {
    backgroundColor: danger ? "#b71c1c" : "#1e8e82",
  },
}));


const MuiButton = ({ onClick, children, variant = "contained", large = false, danger = false, ...props }) => {

	let size ="medium";
	if(large)
		size = "large";
    

  //#26a69a;

  return (
    <CustomButton 
      variant={variant}
      size={size}
      onClick={onClick}
      sx={{ mt: 2}}
      danger={danger}
      {...props}
    >
      {children}
    </CustomButton>
  );
};

export default MuiButton;